import { render, staticRenderFns } from "./goodsSearch.vue?vue&type=template&id=755bed44&scoped=true"
import script from "./goodsSearch.vue?vue&type=script&lang=js"
export * from "./goodsSearch.vue?vue&type=script&lang=js"
import style0 from "./goodsSearch.vue?vue&type=style&index=0&id=755bed44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755bed44",
  null
  
)

export default component.exports